var _path, _path2, _g, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#DE3434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7706 82.5V72.3182H14.9766C15.7389 72.3182 16.3968 72.4673 16.9503 72.7656C17.5071 73.0606 17.9363 73.4732 18.2379 74.0036C18.5395 74.5305 18.6903 75.1437 18.6903 75.843C18.6903 76.5457 18.5362 77.1605 18.228 77.6875C17.9231 78.2112 17.4872 78.6172 16.9205 78.9055C16.3537 79.1939 15.6809 79.3381 14.902 79.3381H12.3068V77.3991H14.4446C14.8158 77.3991 15.1257 77.3345 15.3743 77.2053C15.6262 77.076 15.8168 76.8954 15.946 76.6634C16.0753 76.428 16.1399 76.1546 16.1399 75.843C16.1399 75.5282 16.0753 75.2564 15.946 75.0277C15.8168 74.7957 15.6262 74.6167 15.3743 74.4908C15.1224 74.3648 14.8125 74.3018 14.4446 74.3018H13.2315V82.5H10.7706ZM23.6669 82.5H19.9034V72.3182H23.6619C24.6993 72.3182 25.5926 72.522 26.3416 72.9297C27.094 73.334 27.674 73.9174 28.0817 74.6797C28.4893 75.4387 28.6932 76.3468 28.6932 77.4041C28.6932 78.4647 28.4893 79.3762 28.0817 80.1385C27.6773 80.9008 27.099 81.4858 26.3466 81.8935C25.5942 82.2978 24.701 82.5 23.6669 82.5ZM22.3643 80.402H23.5724C24.1425 80.402 24.6248 80.3059 25.0192 80.1136C25.4169 79.9181 25.7169 79.6016 25.919 79.1641C26.1245 78.7232 26.2273 78.1366 26.2273 77.4041C26.2273 76.6716 26.1245 76.0883 25.919 75.6541C25.7135 75.2166 25.4103 74.9018 25.0092 74.7095C24.6115 74.514 24.121 74.4162 23.5376 74.4162H22.3643V80.402ZM30.13 82.5V72.3182H37.0803V74.3168H32.5909V76.4048H36.6378V78.4084H32.5909V82.5H30.13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2909 46.6414C36.1155 48.6129 35.7659 53.0906 35.4834 56.5146C35.3133 58.5748 33.774 60.2479 31.7388 60.6106L30.7339 60.7897C28.4188 61.2023 26.2977 59.4115 26.3162 57.06V57.06C26.3292 55.4008 27.4207 53.9476 29.0127 53.4801C34.7033 51.809 47.7104 47.9862 53.4375 46.3027C55.1124 45.8103 56.9726 46.3952 58.0712 47.7519L58.4042 48.1631C59.6714 49.7281 59.3861 52.0324 57.7755 53.2411V53.2411C56.4193 54.2589 54.4752 54.2672 53.0759 53.3095C48.0781 49.889 36.6412 42.3312 31.447 38.808C29.8936 37.7543 29.3389 35.8249 30.0261 34.0782L30.2126 33.604C31.0042 31.5918 33.3081 30.639 35.2897 31.5043V31.5043C36.9009 32.2078 37.8534 33.925 37.6275 35.6685C37.1319 39.4934 36.3807 45.6321 36.2909 46.6414Z",
    stroke: "#DE3434",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPdf);
export default __webpack_public_path__ + "static/media/ico_pdf.214c0485fe3955f064966528e1f72d08.svg";
export { ForwardRef as ReactComponent };